<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import vue2Dropzone from "vue2-dropzone";

/**
 * Starter component
 */
export default {
  head () {
    return {
      title: `${this.title} | Minton - Nuxtjs Responsive Admin Dashboard Template`,
    };
  },
  data () {
    return {
      title: "文法小測驗",
      items: [
        {
          text: "法語鸚鵡螺",
          href: "/",
        },
        {
          text: "文法測驗第一層級",
          link: "/plugin/voices/list"
        },
        {
          text: "文法測驗第二層級",
          active: true,
        }
      ],
      type: 2,
      pluginTypeItem: {},
      pluginItem: {
        id: "",
        image: "",
        title: "",
        des: "",
        html: ""
      },
      pluginThemes: [],
      currentPage: 1,
      totalRows: 1,
      perPage: 15,
      ctaContent: {
        title: "",
        content: "",
        buttonText: "",
        buttonUrl: ""
      },
      showHtmlEditor: false,
      dropzoneOptions: {
        url: process.env.VUE_APP_UPLD_URL + '/theme/default',
        method: "post",
        uploadMultiple: false,
        paramName: "files[0]",
        maxFilesize: 2048,
        // headers: {
        //   "Authorization": 'Bearer ' + this.$root.auth_token,
        // },
        previewTemplate: this.template(),
      },
    };
  },
  components: {
    Layout,
    PageHeader,
    vueDropzone: vue2Dropzone,
  },
  created () {
    this.itemId = this.$route.params.itemId
    this.$root.apis.getTypeItem(this.itemId, this.processGetTypeItemSuccess)
    this.getPluginThemes()
  },
  methods: {
    processGetTypeItemSuccess (_response) {
      this.pluginTypeItem = _response.body
      this.ctaContent.title = this.pluginTypeItem.cta_title
      this.ctaContent.content = this.pluginTypeItem.cta_content
    },
    getPluginThemes () {
      this.$root.apis.getPluginThemes(this.itemId, this.currentPage, this.processGetThemesSuccess)
    },
    processGetThemesSuccess (_response) {
      console.log("_response.body.data:", _response.body.items);

      this.currentPage = _response.body.page
      this.totalRows = _response.body.total
      this.perPage = _response.body.per_page
      this.pluginThemes = _response.body.items
    },
    // 圖片上傳成功時
    uploadImageSuccess (file, response) {
      console.log("Upload Response:", response)
      this.pluginItem.image = response.data[0].url
      alert("檔案上傳成功！")
    },
    template: function () {
      return ` <div class="dropzone-previews mt-3">
            <div class="card mt-1 mb-0 shadow-none border">
                <div class="p-2">
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <img data-dz-thumbnail src="#" class="avatar-sm rounded bg-light" alt="">
                        </div>
                        <div class="col pl-0">
                            <a href="javascript:void(0);" class="text-muted font-weight-bold" data-dz-name></a>
                            <p class="mb-0" data-dz-size></p>
                        </div>
                        <div class="col-auto">
                            <!-- Button -->
                            <a href="" class="btn btn-link btn-lg text-muted" data-dz-remove>
                                <i class="fe-x"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
    },
    createPlugin () {
      this.pluginItem = {
        id: "",
        image: "",
        title: "",
        des: "",
        html: ""
      }
      this.$bvModal.show('modal-responsive')
    },
    setCTAContent () {
      this.$bvModal.show('modal-cta')
    },
    saveCTAContent () {
      let targetPluginTypeId = this.$route.params.itemId
      this.$root.apis.setThemeCTA(
        targetPluginTypeId,
        this.ctaContent,
        this.processSaveCTASuccess
      )
    },
    processSaveCTASuccess (_response) {
      this.$bvToast.toast('CTA內容已保存', {
        title: '成功',
        variant: 'success',
        solid: true
      })
      this.$bvModal.hide('modal-cta')
    },
    editorPlugin (_pluginTheme) {
      _pluginTheme.html =
        `<iframe  style="max-width:100%" src="${this.$root.pluginUri}/plugin/${_pluginTheme.id}?memberId=&email=&planMin=" width="800" height="500" frameborder="0" allow="microphone" allowfullscreen></iframe>`
      this.pluginItem = _pluginTheme
      this.$bvModal.show('modal-responsive')
    },
    editorContent (_pluginTheme) {
      this.$router.push("/plugin/voices/topics/" + _pluginTheme.id)
    },
    openPreviewItem (_id) {
      window.open(this.$root.pluginUri + "/plugin/demo/" + _id)
    },
    createItem () {
      this.$root.apis.createPluginTheme(this.itemId, this.pluginItem, this.processCreateItemSuccess)
    },
    processCreateItemSuccess (_response) {
      this.$bvModal.hide('modal-responsive')
      this.getPluginThemes()
    },
    updateItem () {
      let vm = this
      let _item = this.pluginItem
      this.$root.apis.putThemeItem(_item.id, _item, function () {
        vm.$bvModal.hide('modal-responsive')
        vm.getPluginThemes()
      })
    },
    removeItem (_itemId) {
      if (!confirm("確認要刪除項目嗎？")) {
        return
      }
      this.$root.apis.delThemeItem(_itemId, this.getPluginThemes)
    },
    toggleHtmlEditor () {
      this.showHtmlEditor = !this.showHtmlEditor
    },
    // 處理分頁切換
    onPageChange (page) {
      this.currentPage = page
      this.getPluginThemes()
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12 col-xl-12">
        <b-card>
          <div class="row">
            <div class="col-3 text-left">
              <b-button variant="primary" type="button" @click="setCTAContent">設定CTA</b-button>
            </div>
            <div class="col-3"></div>
            <div class="col-3"></div>
            <div class="col-3 text-right">
              <b-button variant="primary" type="button" @click="createPlugin">增加模組</b-button>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <!-- 分頁元件 - 靠右 -->
    <div class="row justify-content-end">
      <div class="col-auto">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
          @change="onPageChange"></b-pagination>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-xl-3" v-for="(pluginTheme, index) in pluginThemes">
        <b-card
          :img-src="$root.mediaUri + (pluginTheme.image ? pluginTheme.image : '/resources/images/default-item-image.jpg')"
          img-alt="Card image" img-top>
          <b-card-title>
            <h5 class="card-title">{{ pluginTheme.title }}</h5>
          </b-card-title>
          <b-card-text>{{ pluginTheme.des }}</b-card-text>
          <div class="row">
            <div class="col text-center">
              <b-button type="button" variant="primary" @click="editorPlugin(pluginTheme)">設定</b-button>
            </div>
            <div class="col text-center">
              <b-button type="button" variant="primary" @click="editorContent(pluginTheme)">題目</b-button>
            </div>
            <div class="col text-center">
              <b-button type="button" variant="danger" @click="removeItem(pluginTheme.id)">刪除</b-button>
            </div>
          </div>
        </b-card>
      </div>
      <!-- end col -->
    </div>

    <!-- 分頁元件 - 靠左 -->
    <div class="row">
      <div class="col-12">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
          @change="onPageChange"></b-pagination>
      </div>
    </div>

    <b-modal id="modal-responsive" :title="(pluginItem.id) ? '編輯模組' : '新增模組'" title-class="font-18" body-class="p-4"
      hide-footer>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="field-1" class="control-label">標題</label>
            <input v-model="pluginItem.title" type="text" class="form-control" placeholder="" />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="field-2" class="control-label">簡述</label>
            <textarea v-model="pluginItem.des" class="form-control" placeholder="" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <vue-dropzone id="dropzone" ref="myVueDropzone" :use-custom-slot="true" :options="dropzoneOptions"
            @vdropzone-success="uploadImageSuccess">
            <div class="dz-message needsclick">
              <i class="h1 text-muted ri-upload-cloud-2-line"></i>
              <h3>拖移圖片檔案或點擊此視窗</h3>
              <span class="text-muted font-13">(僅限使用 JPEG / JPG / PNG 檔案)</span>
            </div>
          </vue-dropzone>
        </div>
      </div>
      <div class="row pt-2" v-if="pluginItem.id">
        <div class="col-md-12">
          <h5>
            <span>HTML 複製</span>
            <small class="pl-2 preview-btn" @click="openPreviewItem(pluginItem.id)">檢視</small>
          </h5>
          <textarea class="code-style" rows="5" readonly>{{ pluginItem.html }}</textarea>
          <small>memberId: 用戶在鸚鵡螺主站的 ID 編號 (非必填)</small>
          <br>
          <small>email: 用戶的 Email (必填), ex: admin@jbravo.dev</small>
          <br>
          <small>planMin: 用戶單月分鐘數方案 (與 totalMin 二選一填寫), ex: 99</small>
          <br>
          <small>totalMin: 用戶總共可使用多少分鐘數 (與 planMin 二選一填寫), ex: 999</small>
        </div>
      </div>
      <div class="text-center pt-3">
        <b-button type="button" @click="createItem" v-if="!pluginItem.id">建立</b-button>
        <b-button type="button" @click="updateItem" v-else>更新</b-button>
      </div>
    </b-modal>

    <!-- CTA内容编辑模态框 -->
    <b-modal id="modal-cta" title="設定CTA內容" title-class="font-18" body-class="p-4" size="lg" hide-footer>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="cta-title" class="control-label">標題</label>
            <input v-model="ctaContent.title" type="text" class="form-control" placeholder="輸入CTA標題" />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="cta-content" class="control-label">內容</label>
            <div class="mb-2">
              <b-button size="sm" variant="outline-secondary" @click="toggleHtmlEditor">
                {{ showHtmlEditor ? '切換到富文本編輯' : '切換到HTML編輯' }}
              </b-button>
            </div>
            <quill-editor v-if="!showHtmlEditor" v-model="ctaContent.content" :options="{
              placeholder: '輸入CTA內容...',
              modules: {
                toolbar: [
                  ['bold', 'italic', 'underline'],
                  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                  [{ 'color': [] }, { 'background': [] }],
                  [{ 'align': [] }],
                  ['link']
                ]
              }
            }" />
            <textarea v-else v-model="ctaContent.content" class="form-control" rows="10" placeholder="輸入HTML內容..."
              style="font-family: monospace;"></textarea>
          </div>
        </div>
      </div>
      <div class="text-center pt-3">
        <b-button type="button" variant="primary" @click="saveCTAContent">保存</b-button>
        <b-button type="button" variant="secondary" @click="$bvModal.hide('modal-cta')" class="ml-2">取消</b-button>
      </div>
    </b-modal>

  </Layout>
</template>


<style lang="css" scoped>
.code-style {
  background: #eee;
  color: #333;
  width: 100%;
  padding: 10px;
  word-wrap: break-word;
}

.preview-btn {
  color: #00F;
  cursor: pointer;
}
</style>